export enum TimeViewEnum {
  HOURS = 'hours',
  MINUTES = 'minutes',
}
